function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="18" height="18" viewBox="0 0 18 18" {...props}><path d="M9 17.885a8.842 8.842 0 0 0 6.277-2.608c3.461-3.462 3.461-9.092 0-12.554-3.462-3.461-9.092-3.461-12.554 0-3.461 3.462-3.461 9.092 0 12.554A8.842 8.842 0 0 0 9 17.885zM3.53 3.53A7.723 7.723 0 0 1 9 1.269a7.73 7.73 0 0 1 5.47 13.2 7.73 7.73 0 0 1-10.94 0 7.73 7.73 0 0 1 0-10.938z" /><path d="M5.885 13.038c.161 0 .3-.069.415-.184l3-3.254a.655.655 0 0 0 .162-.392V4.846a.571.571 0 0 0-.577-.577.571.571 0 0 0-.577.577V9l-2.862 3.07c-.208.23-.208.6.023.807a.592.592 0 0 0 .416.161z" /></svg>;
});